import React, { Component, PureComponent, PropTypes } from 'react';
import LabelsGridCell from './LabelsGridCell';
import { camelCaseToTitleCase } from '../../../../helpers/camelCaseToTitleConverter';
export default class LabelsGridRow extends PureComponent {
    static propTypes = {
        labelKey: PropTypes.string.isRequired,
        selectedLanguages: PropTypes.array.isRequired,
        hasAccess: PropTypes.object.isRequired
    };

    render() {
        return (
            <tr
                className={!(this.props.hasAccess.view || this.props.hasAccess.edit) && 'spark-table__disabled-row'}
                key={this.props.labelKey}
            >
                <td key="label">
                    <div>
                        <b>
                            {this.props.labelKey.replace(/shs-sbem--?/, '')
                                .split('.')
                                .map(camelCaseToTitleCase)
                                .join(': ')}
                        </b>
                    </div>
                    <div>{this.props.labelKey}</div>
                </td>
                {this.props.selectedLanguages.map((languageCode, i) => {
                    return (
                        <LabelsGridCell
                            labelKey={this.props.labelKey}
                            languageCode={languageCode}
                            key={languageCode}
                            hasAccess={this.props.hasAccess}
                        />
                    );
                })}
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/pages/search/labelsGrid/LabelsGridRow.js